//background-video-alt-img
    document.addEventListener("DOMContentLoaded", function() {
      if (!sessionStorage.getItem("firstLoadDone")) {
        sessionStorage.setItem("firstLoadDone", "true");
        window.scrollTo(0, 0);
        setTimeout(() => window.scrollTo(0, 0), 10);
      }
    });
    document.addEventListener("DOMContentLoaded", function() {
      document.querySelectorAll("video.section-video img").forEach(function(img) {
        if (!img.hasAttribute("alt")) {
          img.setAttribute("alt", "Video thumbnail image");
        }
      });
    });

    document.addEventListener("DOMContentLoaded", function () {
      const lazyVideos = document.querySelectorAll("video.section-video");
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const video = entry.target;
            const source = video.querySelector("source");
            if (source && source.src) {
              video.play();
            }
            observer.unobserve(video);
          }
        });
      }, { threshold: 0.25 }); 

      lazyVideos.forEach(video => {
        videoObserver.observe(video);
      });
    });


    document.addEventListener("DOMContentLoaded", function () {
      if(window.innerWidth <= 768) {
        document.querySelectorAll('.product-blocks__block--accordion-item .js-accordion-header').forEach((header)=>{
          header.setAttribute('aria-expanded', 'false');
        })
        document.querySelectorAll('.product-blocks__block--accordion-item .c-accordion__panel').forEach((header)=>{
          header.classList.remove('is-active'); 
        })
      }
    });

    document.addEventListener("DOMContentLoaded", function () {

      const forms = document.querySelectorAll('[action="/contact#section_newsletter_form"]');
      forms.forEach((form) => {
        const emailInput = form.querySelector('[name="contact[email]"]');
        if (!emailInput) return;
        form.addEventListener("submit", function (e) {
          const value = emailInput.value.trim();
          if (!value) {
            e.preventDefault()
            e.stopImmediatePropagation()
          };
          // Remove old error
          const oldError = form.querySelector(".note.note-error");
          const oldsuccess = form.querySelector(".note.note-success");
          if (oldError) oldError.remove();
          if (oldsuccess) oldsuccess.remove();
          if (!value) {
            // Create error block
            const errorDiv = document.createElement("div");
            errorDiv.classList.add("note", "note-error", "mb1");
            errorDiv.innerHTML = `
              <div class="inline-block v-center">
                  <svg class="icon--apollo-error mr3" height="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <g class="hover-fill" fill="var(--error-msg-dark)">
                      <path d="M9,13h2v2H9V13z M9,5h2v6H9V5z M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10c5.5,0,10-4.5,10-10S15.5,0,10,0z M10,18
                      c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S14.4,18,10,18z"></path>
                    </g>
                  </svg>
              </div>
              <p class="sm-caps inline-block v-center mb0">Email can't be blank.</p>
            `;

            form.insertAdjacentElement("afterbegin", errorDiv);
          }
        });
      });

    });

 
document.addEventListener("DOMContentLoaded", function () {
  const lazyVideos = document.querySelectorAll(".product-gallery__product-video iframe");
  document.querySelector('#main-image-gallery')?.addEventListener('click', (e) => {
    const isExternalThumb = e.target.closest('.external_video-thumbnail');
    const isSlideBtn = e.target.closest('#main-slider .flickity-button');
    lazyVideos.forEach(video => {
      if (!video || video.tagName.toLowerCase() !== "iframe") return;
      let videoSrc = video.src;
      // Remove any existing mute=0 or mute=1 param
      videoSrc = videoSrc.replace(/([&?])mute=[01]/, '');
      const hasQuery = videoSrc.includes('?');
      const separator = hasQuery ? '&' : '?';
      if (isExternalThumb || isSlideBtn) {
        // CLICKED ON EXTERNAL THUMB → SET mute=1
        if (!videoSrc.includes('mute=0')) {
          video.src = `${videoSrc}${separator}mute=0`;
        }
      } else {
        // CLICKED ANYTHING ELSE → SET mute=0
        if (!videoSrc.includes('mute=1')) {
          video.src = `${videoSrc}${separator}mute=1`;
        }
      }
    });

  });
});



// // new js preorder


// function isVariantAvailable(v){
//   if(!v) return false;
//   return v.inventory_policy === "continue" || v.inventory_quantity > 0;
// }

// function getSelectedVariant(){

//   const options = [];

//   document.querySelectorAll(".swatches__form--input:checked").forEach(radio=>{
//     options.push(radio.value);
//   });

//   if(options.length === 0){
//     return window.productVariants[0] || null;
//   }

//   const variant = window.productVariants.find(v =>
//     v.option1 === options[0] &&
//     (v.option2 === options[1] || !v.option2) &&
//     (v.option3 === options[2] || !v.option3)
//   );

//   return variant || null;
// }

// function hasAnyAvailableVariant(){
//   return window.productVariants.some(isVariantAvailable);
// }

// function updatePreorderButton(){

//   const btn = document.querySelector('button[name="add"]');
//   const stickyBtn = document.querySelector('.sticky-atc-bar__actions button');

//   if(!btn) return;

//   const variant = getSelectedVariant();

//   function apply(btnEl){
//     if(!btnEl) return;

//     if(!hasAnyAvailableVariant()){
//       btnEl.classList.add("disabled");
//       btnEl.classList.remove("preorder-active");
//       btnEl.textContent = "Sold Out";
//       btnEl.disabled = true;
//       return;
//     }

//     if(!variant){
//       btnEl.classList.add("disabled");
//       btnEl.classList.remove("preorder-active");
//       btnEl.textContent = "Sold Out";
//       btnEl.disabled = true;
//       return;
//     }

//     if(variant.inventory_quantity <= 0 && variant.inventory_policy !== "continue"){
//       btnEl.classList.add("disabled");
//       btnEl.classList.remove("preorder-active");
//       btnEl.textContent = "Sold Out";
//       btnEl.disabled = true;
//       return;
//     }

//     if(variant.inventory_quantity <= 0 && variant.inventory_policy === "continue"){
//       btnEl.classList.remove("disabled");
//       btnEl.classList.add("preorder-active");
//       btnEl.textContent = "Pre-Order";
//       btnEl.disabled = false;
//       return;
//     }

//     btnEl.classList.remove("disabled", "preorder-active");
//     btnEl.textContent = "Add to Cart";
//     btnEl.disabled = false;
//   }

//   apply(btn);
//   apply(stickyBtn);
// }


// document.addEventListener("change", function(e){
//   if(e.target.classList.contains("swatches__form--input")){
//     setTimeout(updatePreorderButton, 30);
//   }
// });

// document.addEventListener("DOMContentLoaded", function(){
//   updatePreorderButton();
// });



// new js preorder

function isUntracked(v){
  return v && "inventory_management" in v && !v.inventory_management;
}

function isVariantAvailable(v){
  if(!v) return false;
  if(isUntracked(v)) return true; // [NEW]
  return v.inventory_policy === "continue" || v.inventory_quantity > 0;
}

function getSelectedVariant(){

  const options = [];

  document.querySelectorAll(".swatches__form--input:checked").forEach(radio=>{
    options.push(radio.value);
  });

  if(options.length === 0){
    return window.productVariants[0] || null;
  }

  const variant = window.productVariants.find(v =>
    v.option1 === options[0] &&
    (v.option2 === options[1] || !v.option2) &&
    (v.option3 === options[2] || !v.option3)
  );

  return variant || null;
}

function hasAnyAvailableVariant(){
  return window.productVariants.some(isVariantAvailable);
}

function updatePreorderButton(){

  if(!window.productVariants || !window.productVariants.length) return; // [NEW]

  const btn = document.querySelector('button[name="add"]');
  const stickyBtn = document.querySelector('.sticky-atc-bar__actions button');

  if(!btn) return;

  const variant = getSelectedVariant();

  function setText(btnEl, text){
    if(btnEl.textContent.trim() !== text) btnEl.textContent = text;
  }

  function apply(btnEl){
    if(!btnEl) return;

    if(!hasAnyAvailableVariant()){
      btnEl.classList.add("disabled");
      btnEl.classList.remove("preorder-active");
      setText(btnEl, "Sold Out");
      btnEl.disabled = true;
      return;
    }

    if(!variant){
      btnEl.classList.add("disabled");
      btnEl.classList.remove("preorder-active");
      setText(btnEl, "Sold Out");
      btnEl.disabled = true;
      return;
    }

    if(isUntracked(variant)){
      btnEl.classList.remove("disabled", "preorder-active");
      setText(btnEl, "Add to Cart");
      btnEl.disabled = false;
      return;
    }

    if(variant.inventory_quantity <= 0 && variant.inventory_policy !== "continue"){
      btnEl.classList.add("disabled");
      btnEl.classList.remove("preorder-active");
      setText(btnEl, "Sold Out");
      btnEl.disabled = true;
      return;
    }

    if(variant.inventory_quantity <= 0 && variant.inventory_policy === "continue"){
      btnEl.classList.remove("disabled");
      btnEl.classList.add("preorder-active");
      setText(btnEl, "Pre-Order");
      btnEl.disabled = false;
      return;
    }

    btnEl.classList.remove("disabled", "preorder-active");
    setText(btnEl, "Add to Cart");
    btnEl.disabled = false;
  }

  apply(btn);
  apply(stickyBtn);
}


document.addEventListener("change", function(e){
  if(e.target.classList.contains("swatches__form--input")){
    updatePreorderButton();
  }
});

function initPreorder(){
  updatePreorderButton();
  document.documentElement.classList.add("atc-ready");

  const target = document.querySelector('button[name="add"]');
  if(target){
    new MutationObserver(updatePreorderButton).observe(target, {
      childList: true, characterData: true, subtree: true
    });
  }
  const sticky = document.querySelector('.sticky-atc-bar__actions button');
  if(sticky){
    new MutationObserver(updatePreorderButton).observe(sticky, {
      childList: true, characterData: true, subtree: true
    });
  }
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded", initPreorder);
}else{
  initPreorder();
}

setTimeout(function(){ document.documentElement.classList.add("atc-ready"); }, 1500);


// collection page


document.addEventListener("DOMContentLoaded", function(){

  function updateButton(container){

    const btn = container.querySelector('.js-ajax-submit');
    const script = container.querySelector(".product-json");

    if(!btn || !script) return;

    let productData = {};

    try{
      productData = JSON.parse(script.textContent || "{}");
    }catch(e){
      return;
    }

    const variants = productData.variants || [];

    let variantId = btn.getAttribute("data-variant-id");

    let variant;

    if(variantId){
      variant = variants.find(v => v.id == variantId);
    }else{
      variant = variants[0];
    }

    if(!variant) return;

    if(variant.inventory_policy === "continue" && variant.inventory_quantity <= 0){
      btn.value = "Pre-Order";
    } else {
      btn.value = "Add to Cart";
    }

  }


  // 🚀 page load
  document.querySelectorAll(".product-loop__item").forEach(container=>{
    updateButton(container);
  });


  // 🔁 swatch change
  document.addEventListener("change", function(e){

    const container = e.target.closest(".product-loop__item");
    if(container){
      setTimeout(()=> updateButton(container), 100);
    }

  });

});



// collection page


